import { render } from "./change-stock.vue?vue&type=template&id=4b30ccb0&scoped=true&ts=true"
import script from "./change-stock.vue?vue&type=script&lang=tsx"
export * from "./change-stock.vue?vue&type=script&lang=tsx"

import "./change-stock.vue?vue&type=style&index=0&id=4b30ccb0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b30ccb0"]])

export default __exports__